/* eslint-disable jsx-a11y/alt-text */
import { createColumnHelper } from "@tanstack/react-table";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  fetchProductCodeManagementDownload,
  useProductCodeManagementList,
} from "../../../api/product-code-management/use-product-code";
import Table from "../../../components/ui/Table/Table";

import { Pagination } from "../../../components/ui/Table/Pagination/Pagination";
import Modal from "../../../components/ui/Modal/Modal";
import { SaveIcon } from "../../../assets/icons";

const columnHelper = createColumnHelper();

const sorts = [
  {
    id: 1,
    name: "최신순",
  },
  {
    id: 2,
    name: "오래된순",
  },
  {
    id: 3,
    name: "접수 수량 많은 순",
  },
  {
    id: 4,
    name: "접수 수량 적은 순",
  },
  {
    id: 5,
    name: "결제일시 순",
  },
];

const columns = (page, pageSize, total) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexVal =
          page === 1 ? total - index : total - index - (page - 1) * pageSize;

        return <div>{indexVal}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.productNo, {
      header: "주문구분",
      cell: () => {
        return <div>불량접수</div>;
      },
    }),

    columnHelper.accessor((row) => row?.mainImage, {
      header: "상태",
      cell: () => {
        return <div className="text-secondary-red">불량접수</div>;
      },
    }),

    columnHelper.accessor((row) => row?.productGroupCategory, {
      header: "접수번호",
      cell: () => {
        return (
          <div>
            MM2209152359
            <br />
            -004-06-06
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "카테고리",
      cell: () => {
        return <div>기타 카테고리</div>;
      },
    }),

    columnHelper.accessor((row) => row?.productQty, {
      header: "상품코드(REF)",
      cell: () => {
        return <div>S35085C</div>;
      },
    }),

    columnHelper.accessor((row) => row?.qrQty, {
      header: "상품명",
      cell: () => {
        return (
          <div>
            상품명 공백포함 65자
            <br />
            이내 입력가능상품명...
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.qrQty, {
      header: "주문자(담당자)",
      cell: () => {
        return (
          <div>
            병원명병원명병원명
            <br />
            testtesttest@test.com
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.qrQty, {
      header: "접수 수량",
      cell: () => {
        return <div>1</div>;
      },
    }),

    columnHelper.accessor((row) => row?.qrQty, {
      header: "상품 결제일시",
      cell: () => {
        return (
          <div>
            2022-01-01
            <br />
            23:59:59
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.qrQty, {
      header: "접수일시",
      cell: () => {
        return (
          <div>
            2022-10-30
            <br />
            23:59:59
          </div>
        );
      },
    }),

    columnHelper.display({
      header: "자세히 보기",
      id: "actions",
      cell: ButtonActions,
    }),
  ];
};

function ButtonActions(props) {
  const id = "/defect-reception/detail";
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`${id}`)}
      className="w-10 p-[1px] border border-[#cccccc] rounded-[4px] text-[#333333]"
    >
      상세
    </button>
  );
}

export function DefectReceptionTable(props) {
  const { filter } = props;
  const { isEmpty, getDataTableProps } = useProductCodeManagementList(filter);
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().totalAll;

  const onSave = async () => {
    await fetchProductCodeManagementDownload().then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `product-code-${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  return (
    <>
      {/* {isEmpty ? (
        <>
          <div className="text-title-grey flex justify-center py-20 w-full">
            등록된 내역이 없습니다.
          </div>
        </>
      ) : ( */}
      <>
        <div className="absolute top-[21rem]">
          총 불량접수 수량 <span className="font-bold">125</span>개 | 배송완료 수량 <span className="font-bold">125</span>개
        </div>
        <Table
          hasPageSizeFilter={false}
          hasPagination={false}
          sorts={sorts}
          dropdownWidth={`w-[170%]`}
          positionDropdown={`right-0`}
          onSave={onSave}
          columns={columns(currentPage, pageSize, totalData)}
          {...getDataTableProps()}
        />
        
        <div className="mt-8 flex justify-center overflow-auto">
          <Pagination
          //   total={table.getPageCount()}
          //   page={table.getState().pagination.pageIndex}
          //   isDisabledPrevPage={!table.getCanPreviousPage()}
          //   isDisabledNextPage={!table.getCanNextPage()}
          //   onPrevClick={() => table.previousPage()}
          //   onNextClick={() => table.nextPage()}
          //   onChange={(nextPage) => table.setPageIndex(nextPage)}
          //   onLastClick={() => table.setPageIndex(table.getPageCount())}
          //   onFirstClick={() => table.setPageIndex(0)}
          />
          <div className="flex-none">
            <Modal
              hasCancel={false}
              description="다운로드 되었습니다."
              onSubmit={() => {}}
            >
              <button
                // onClick={onSave}
                className="px-[10px] py-[5px] border border-[#cccccc] rounded-[4px] text-[#333333]"
              >
                <div className="flex items-center gap-2">
                  <SaveIcon />
                  엑셀 저장
                </div>
              </button>
            </Modal>
          </div>
        </div>
      </>
      {/* )} */}
    </>
  );
}
